<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">

        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title"> Статистика</h3>
            </div>
            <div class="container-fluid">
              <br>
              <div class="row">
                <div class="col-6">
                  <v-select
                      label="name"
                      :options="nom"
                      :reduce="(option) => option"
                      v-model="search.data"
                      class="form-group"
                  >
                  </v-select>
                </div>

                <div class="col-2">
                  <input type="date" v-model="search.date_start" class="form-control">
                </div>
                <div class="col-2">
                  <input type="date" v-model="search.date_finish" class="form-control" >
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-success" @click="Search">
                    <span class="glyphicon glyphicon-filter">Фильтр</span>
                  </button>
                  <button type="button" class="btn btn-info">
                    <span class="glyphicon glyphicon-remove" @click="clearSearchItem()">Сброс</span>
                  </button>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <div class="card">
                    <div class="container">
                      <div class="card-heading">
                        <h3 class="card-title">Заказы</h3>
                      </div>
                      <br>
                      &ensp; Заказов за выбранный период <font style="color: #064cd6"v-if="results"> {{results.all}} </font> заказа, кол-во <font
                        style="color: #b43cc4">{{results.sum}} </font> шт.<br>
                      <br>
                    </div>
                  </div>
                </div>
                <br>
                <br>
                <div class="col-md-6 col-sm-12">
                  <div class="card card-success">
                    <div class="card-heading">
                      <h3 class="card-title">Заказы по дням</h3>
                    </div>
                    <br>

                    <div class="container">
                      <span v-if="results && results.day.length>0" v-for="item in results.day">
                              Дата <font style="color: #064cd6">{{item.date}}</font> Количество <font style="color: #b43cc4">{{item.number}}</font><br>
                      </span>
                      <br>
                      <br>
                    </div>
                  </div>
                </div>

              </div>
              <br>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      keywords: null,
      editmode: false,
      results: [],
      nom: [],
      search: {
        'data': '',
        'cid': '',
        'date_start': '',
        'date_finish': '',
        'weight': '',
      },
      urls: {
        getdata: "api/search?page=",
        nomenclature: "/api/catalog/any",
      }
    };
  },
  methods: {
    // methodThatForcesUpdate() {
    //   //  this.$forceUpdate();
    // }

    loadNomenclatura() {
      axios.get(this.urls.nomenclature)
          .then(response => {
            this.nom = response.data;
          })
          .catch((errors) => {
            this.toastError(errors.response.data.errors);
          });
    },

    clearSearchItem() {
       this.search.cid = '';
       this.search.date_start = '';
       this.search.date_finish = '';
       this.search.weight = '';
      //  this.getResults(1);
    },

    Search() {

     // if (search.length) {
      this.search.cid=this.search.data.id;
      this.search.weight=this.search.data.weight;
        axios.get(this.urls.getdata, {
          params: {
            cid: this.search.cid,
            date_start: this.search.date_start,
            date_finish: this.search.date_finish,
            weight: this.search.weight,
          }
        })
            .then(({ data }) => (this.results = data.data))
            .catch(error => {});


    },


  },
  created() {
    this.loadNomenclatura();
  },
  computed: {
    sum: function () {
     // // console.log(1234,this.results.length);
     //  var sum=0;
     //
     //  if (this.results.length >0){
     //    for (var i=0; this.results.length>i; i++){
     //      if(i!=0) {
     //        sum =sum + this.results[i]['number'];
     //      }else{
     //        sum = this.results[i]['number'];
     //      }
     //      console.log(i, sum);
     //    }
     //  //  var sum=18;
     //  }
     //
     //  return sum;
    }
  }
}
</script>

<style>
.search {
  position: relative;
}

.search_form {
  z-index: 700;
  position: absolute;
  inset: 0px auto auto 11px;
  transform: translate3d(0em, 4em, 0px);
}

.search_result {
  background: #FFF;
  border: 1px #ccc solid;
  width: auto;
  border-radius: 1em;
  max-height: 15em;
  overflow-y: scroll;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  box-shadow: rgb(0 145 228 / 9%) 7px 7px 0px 1px;
}

.search_result li {
  list-style: none;
  padding: 5px 10px;
  margin: 0 0 0 0px;
  color: #4f5558;
  border-bottom: 1px #ccc solid;
  cursor: pointer;
  /*text-align: left;*/
  transition: 0.3s;
}

.search_result li:hover {
  background: #8cbfd4;
  color: white;
}

.search_result li:active {
  background: #51b1e3;
  color: white;
}



.d-center {
  display: flex;
  align-items: center;
}

.selected img {
  width: auto;
  max-height: 23px;
  margin-right: 0.5rem;
}

.col-md-6, .col-md-12 {
  padding-top: 0px;
  padding-right: 12px;
  padding-bottom: 0px;
  padding-left: 12px;
}


</style>
